import { render, staticRenderFns } from "./LabelCustomLabels.vue?vue&type=template&id=7f21a249&"
import script from "./LabelCustomLabels.vue?vue&type=script&lang=ts&"
export * from "./LabelCustomLabels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports